import PropTypes from "prop-types";

export default PropTypes.shape({
  degreeRequired: PropTypes.bool.isRequired,
  visaSponsorship: PropTypes.bool.isRequired,
  considerRelocation: PropTypes.bool.isRequired,
  benefitIds: PropTypes.arrayOf(PropTypes.number).isRequired,
});
